import { useState } from 'react';

const photos = [
  {
    src: 'https://storage.readdy-site.link/project_files/1c0c504f-5b8b-4291-9378-19346b5e3acb/WhatsApp-Image-2026-04-11-at-6.22.38-PM.jpeg?v=g1',
    caption: 'Palazzo Polo Awareness Drive — Kano',
    tag: 'Outreach',
    wide: false,
  },
  {
    src: 'https://storage.readdy-site.link/project_files/1c0c504f-5b8b-4291-9378-19346b5e3acb/WhatsApp-Image-2026-04-11-at-6.22.38-PM-1.jpeg?v=g2',
    caption: 'Restaurant staff join the epilepsy awareness movement',
    tag: 'Community',
    wide: true,
  },
  {
    src: 'https://storage.readdy-site.link/project_files/1c0c504f-5b8b-4291-9378-19346b5e3acb/WhatsApp-Image-2026-04-11-at-6.22.36-PM.jpeg?v=g3',
    caption: 'Supporters holding IKIRU awareness signs at Palazzo Polo',
    tag: 'Outreach',
    wide: false,
  },
  {
    src: 'https://storage.readdy-site.link/project_files/1c0c504f-5b8b-4291-9378-19346b5e3acb/WhatsApp-Image-2026-04-11-at-6.22.34-PM.jpeg?v=g4',
    caption: '"End Epilepsy Stigma" — Seizures Are Not Contagious',
    tag: 'Advocacy',
    wide: false,
  },
  {
    src: 'https://storage.readdy-site.link/project_files/1c0c504f-5b8b-4291-9378-19346b5e3acb/WhatsApp-Image-2026-04-11-at-6.22.33-PM-1.jpeg?v=g5',
    caption: 'Community members standing with epilepsy warriors',
    tag: 'Community',
    wide: false,
  },
  {
    src: 'https://storage.readdy-site.link/project_files/1c0c504f-5b8b-4291-9378-19346b5e3acb/WhatsApp-Image-2026-04-11-at-6.22.33-PM.jpeg?v=g6',
    caption: '"End Epilepsy Stigma" — IKIRU awareness campaign',
    tag: 'Advocacy',
    wide: false,
  },
  {
    src: 'https://storage.readdy-site.link/project_files/1c0c504f-5b8b-4291-9378-19346b5e3acb/WhatsApp-Image-2026-04-11-at-6.22.29-PM-1.jpeg?v=g7',
    caption: 'Purple Day Series: Epilepsy Unfiltered — Wazobia FM 95.1',
    tag: 'Media',
    wide: false,
  },
  {
    src: 'https://storage.readdy-site.link/project_files/1c0c504f-5b8b-4291-9378-19346b5e3acb/WhatsApp-Image-2026-04-11-at-6.22.29-PM.jpeg?v=g8',
    caption: 'World Autism Awareness Day — Seeing the Whole Person',
    tag: 'Campaigns',
    wide: false,
  },
];

const tags = ['All', 'Outreach', 'Community', 'Advocacy', 'Media', 'Campaigns'];

export default function OutreachGallery() {
  const [activeTag, setActiveTag] = useState('All');
  const [lightbox, setLightbox] = useState<string | null>(null);

  const filtered = activeTag === 'All' ? photos : photos.filter((p) => p.tag === activeTag);

  return (
    <section className="py-24 bg-[#FAF7FC]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-4">
          <span className="text-xs font-semibold uppercase tracking-[4px] text-[#7B2D8B]">On the Ground</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 text-center mb-4">
          Outreach &amp; <span className="text-[#7B2D8B]">Awareness</span> in Action
        </h2>
        <p className="text-gray-500 text-center max-w-xl mx-auto mb-10 leading-relaxed">
          Real moments from our community campaigns, awareness drives, and media engagements across Kano and Nigeria.
        </p>

        {/* Filter tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {tags.map((tag) => (
            <button
              key={tag}
              onClick={() => setActiveTag(tag)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeTag === tag
                  ? 'bg-[#7B2D8B] text-white'
                  : 'bg-white border border-purple-200 text-gray-600 hover:border-[#7B2D8B] hover:text-[#7B2D8B]'
              }`}
            >
              {tag}
            </button>
          ))}
        </div>

        {/* Masonry-style grid */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {filtered.map((photo) => (
            <div
              key={photo.src}
              className="break-inside-avoid group relative rounded-2xl overflow-hidden cursor-pointer"
              onClick={() => setLightbox(photo.src)}
            >
              <img
                src={photo.src}
                alt={photo.caption}
                className="w-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A0A1E]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-[#7B2D8B] text-white text-xs font-semibold mb-2 w-fit">
                  {photo.tag}
                </span>
                <p className="text-white text-sm font-medium leading-snug">{photo.caption}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox */}
        {lightbox && (
          <div
            className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
            onClick={() => setLightbox(null)}
          >
            <button
              className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors cursor-pointer"
              onClick={() => setLightbox(null)}
            >
              <i className="ri-close-line text-xl"></i>
            </button>
            <img
              src={lightbox}
              alt="IKIRU outreach"
              className="max-w-full max-h-[90vh] rounded-2xl object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>
    </section>
  );
}
